export default __webpack_public_path__ + "static/media/back.730ca142.jpeg";